import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";

class AllEnemiesTable extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        width: 100,
        dataIndex: "img",
        key: "img",
        align: "center",
        render: (text, record) => (
          <Link
            to={"/enemyinfo/" + record.enemy_no + "/" + record.enemy_name_en}
          >
            <img
              src={
                "https://onestoppress.com/images/edi_" +
                record.enemy_no +
                ".png"
              }
              alt={record.enemy_name_en}
            />
          </Link>
        ),
      },
      {
        title: "Name",
        width: 130,
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          <Link
            to={"/enemyinfo/" + record.enemy_no + "/" + record.enemy_name_en}
          >
            {record.enemy_name_en}
          </Link>
        ),
      },

      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        width: 100,
        align: "left",
        filters: [
          {
            text: "White",
            value: "White",
          },
          {
            text: "Red",
            value: "Red",
          },
          {
            text: "Floating",
            value: "Floating",
          },
          {
            text: "Black",
            value: "Black",
          },
          {
            text: "Metal",
            value: "Metal",
          },
          {
            text: "Angel",
            value: "Angel",
          },
          {
            text: "Alien",
            value: "Alien",
          },
          {
            text: "Zombie",
            value: "Zombie",
          },
          {
            text: "Relic",
            value: "Relic",
          },
          {
            text: "Base",
            value: "Base",
          },
          {
            text: "Aku",
            value: "Aku",
          },
          {
            text: "Colossal",
            value: "Colossal",
          },
          {
            text: "Behemoth",
            value: "Behemoth",
          },
          {
            text: "Sage",
            value: "Sage",
          }
        ],
        onFilter: (value, record) =>
          record.type.includes(
            record.type.match(new RegExp(value)) !== null
              ? record.type.match(new RegExp(value))[0]
              : "-1"
          ),
      },
    ];
  }

  render() {
    const innerHeight = this.props.viewportHeight;

    return (
      <Table
        columns={this.columns}
        dataSource={this.props.selectedEnemies}
        scroll={{ y: innerHeight }}
        size="small"
        loading={false}
        locale={{
          emptyText: (
            <div>
              View all battle cats enemies.
              <p></p>
              From doges to pigges to cyclones and more, find them all here!
            </div>
          ),
        }}
        pagination={{
          position: "bottom",
          hideOnSinglePage: true,
          showQuickJumper: true,
          showSizeChanger: true,
          defaultPageSize: 100,
          pageSizeOptions: ["25", "50", "100", "600"],
        }}
      />
    );
  }
}

export default AllEnemiesTable;



// WEBPACK FOOTER //
// ./src/components-kr/table/AllEnemiesTable.js